export const environment = {
  production: true,
  i18nPrefix: '',
  apiGatewayDns: 'https://api.cnseg.org.br',
  accessAuthToken: 'Basic NjhiYzdiZGYtMWRhYS00ZDI3LTkyYTgtNjM3MGY2NTNmNjY5OmE3NWZjN2E5LTI5ZjUtNGNiNy05MTJjLTlkNjg4YzlkMjYwZg==',
  clientId: '68bc7bdf-1daa-4d27-92a8-6370f653f669',
  clientSecrect: 'a75fc7a9-29f5-4cb7-912c-9d688c9d260f',
  api: 'https://api.cnseg.org.br/portalservicos',
  lote: 'https://api.cnseg.org.br/lote',
  consulta: 'https://api.cnseg.org.br',
  apiwso2: 'https://api.cnseg.org.br',
  auth: 'auth',
  mock: false,
  version: require('../../package.json').version,
  urlFinanceiro: 'http://financeiro.cnseg.org.br/connect/',
  urlCentralAtendimento: 'https://atendimento.cnseg.org.br/Portal/',
  urlProtecaoDados: 'https://fenaseg-privacy.my.onetrust.com/webform/d1c50a38-ed47-4b75-95f4-c6bd2d3c5541/0aaa86dc-0b3c-4205-aff7-4e3eace440ea',
  refreshToken: 'https://api.cnseg.org.br/login/1.0.0/refresh-token',
  tempoAcesso: 60,
  tempoRestanteRefreshToken: 10,
  urlSistema: 'http://127.0.0.1:3025',
  apiRNSPessoas: 'https://api.cnseg.org.br/rnspessoas/1.0.0/',
  apiRNSCartaoProtegido: 'https://solucoes.cnseg.org.br/experienciaemriscosdiversos/1.0.0',

  apiCoincidenciasRNS: '',
  apiSccp: 'https://solucoes.cnseg.org.br/sccp/1.0.0',
  apiSccpBatch: 'https://solucoes.cnseg.org.br/sccpapi/1.0.0',
  apiRnsPessoasBatch: 'https://api.cnseg.org.br/rnspessoas/1.0.0',
  painelBordo: 'https://api.cnseg.org.br/paineldebordo/consulta',
  recaptcha: {
    siteKey: '6Lew65EpAAAAANcuqePy0rYwMefYxqF0_0GBfApm'
  },
  rnpaTransportes: 'https://api.cnseg.org.br/rnpa-transportes',
  rnpaTransportesANTT: 'https://api.cnseg.org.br/rnpa-transportes-consultar',
  stiGroupId: '06b90660-73e9-48e8-b476-88927fcaea4f',
  stiDatasetId: '546826e2-0ae6-46ba-882e-de8e9a8be5b7',
  stiReportIds: {
    2115: 'cb7a721c-5768-44b9-bf01-3d07f51b4f45',
    2116: '94fd86d7-f39e-4681-95e8-4afa3964bd2a',
    2117: '428cb13e-a18a-4d0c-9e2e-02cfade1ead6',
    2118: '1203fc0c-00b8-4eb6-838e-4b04607b6af7',
    2119: 'cf7acf4b-b8f8-42f1-aa32-2d2f8d6d82b0',
    2120: '7c068d3d-11ce-44e2-9f3e-f3b19eb1e6e0',
    2121: '5826b7e0-7b77-41d0-ac76-8db127f1aa26',
    2122: '5ca047a0-aff3-4555-8c2c-08631149e2ab'
  }
};